// extracted by mini-css-extract-plugin
module.exports = {"TopMenuItem":"TopMenuItem_TopMenuItem__HBVtJ","active":"TopMenuItem_active__1NvmU"};